// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-table-wizard__backdrop {
  position: fixed;
  inset: 0;
  z-index: 1400;
  background: rgba(15, 23, 42, 0.72);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12px;
  padding-bottom: var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));
}

.lt-table-wizard {
  width: min(920px, 100%);
  max-height: min(92vh, 900px);
  background: linear-gradient(
    165deg,
    #0f172a 0%,
    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 18%, #1e293b) 45%,
    #0f172a 100%
  );
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);
  border-radius: 16px;
  box-shadow:
    0 24px 48px rgba(0, 0, 0, 0.45),
    0 0 0 1px rgba(255, 255, 255, 0.04) inset;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: #f8fafc;
}

.lt-table-wizard__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 18px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-table-wizard__header h2 {
  margin: 0;
  font-size: 1.1rem;
  color: #f8fafc;
}

.lt-table-wizard__subtitle {
  margin: 4px 0 0;
  font-size: 0.8rem;
  color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, #f8fafc);
}

.lt-table-wizard__close {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #f8fafc;
  transition: border-color 0.15s, background 0.15s;
}

.lt-table-wizard__close:hover {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.16);
}

.lt-table-wizard__toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.55);
}

.lt-table-wizard__tool-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.lt-table-wizard__tool-label {
  width: 100%;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 70%, #f8fafc);
}

.lt-table-wizard__tool-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.06);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  color: #f8fafc;
  transition:
    border-color 0.15s,
    background 0.15s,
    box-shadow 0.15s,
    transform 0.1s;
}

.lt-table-wizard__tool-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.lt-table-wizard__tool-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.lt-table-wizard__tool-btn--secondary {
  border-color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, transparent);
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 18%, transparent);
}

.lt-table-wizard__tool-btn--secondary:hover:not(:disabled) {
  border-color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 75%, #fff);
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 28%, transparent);
}

.lt-table-wizard__tool-btn--rotate {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, transparent);
}

.lt-table-wizard__tool-btn--rotate:hover:not(:disabled) {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 65%, transparent);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);
}

.lt-table-wizard__tool-btn--active {
  border-color: var(--lt-brand, #0877bc);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);
}

.lt-table-wizard__tool-btn--apply {
  border-color: var(--lt-brand, #0877bc);
  background: linear-gradient(
    135deg,
    var(--lt-brand, #0877bc) 0%,
    color-mix(in srgb, var(--lt-brand, #0877bc) 78%, #000) 100%
  );
  color: #fff;
}

.lt-table-wizard__tool-btn--apply:hover:not(:disabled) {
  box-shadow: 0 8px 20px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);
}

.lt-table-wizard__voice {
  flex: 1 1 220px;
  min-width: min(100%, 240px);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lt-table-wizard__tool-group--voice {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, transparent);
}

.lt-table-wizard__voice-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.lt-table-wizard__voice-hint {
  margin: 0;
  flex: 1 1;
  min-width: 0;
  font-size: 0.72rem;
  line-height: 1.35;
  color: rgba(248, 250, 252, 0.78);
}

.lt-table-wizard__voice-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);
  background: rgba(15, 23, 42, 0.92);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
}

.lt-table-wizard__voice-box-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.88);
}

.lt-table-wizard__voice-dismiss {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: rgba(248, 250, 252, 0.7);
  cursor: pointer;
  font-size: 16px;
}

.lt-table-wizard__voice-dismiss:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.lt-table-wizard__voice-input {
  width: 100%;
  resize: vertical;
  min-height: 52px;
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(2, 6, 23, 0.55);
  color: #f8fafc;
  font: inherit;
  font-size: 0.86rem;
  line-height: 1.4;
}

.lt-table-wizard__voice-input:focus {
  outline: none;
  border-color: var(--lt-brand, #0877bc);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);
}

.lt-table-wizard__voice-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

.lt-table-wizard__banner--voice {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, transparent);
}

.lt-table-wizard__swap-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 18px;
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 22%, transparent);
  border-bottom: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 35%, transparent);
  font-size: 0.82rem;
  color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 35%, #fde68a);
}

.lt-table-wizard__banner {
  margin: 0;
  padding: 8px 18px;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);
  color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #86efac);
  font-size: 0.82rem;
}

.lt-table-wizard__banner--error {
  background: rgba(239, 68, 68, 0.15);
  color: #fecaca;
}

.lt-table-wizard__banner--warn {
  background: rgba(251, 191, 36, 0.14);
  color: #fde68a;
}

.lt-table-wizard__kot-hint {
  margin: 0;
  padding: 8px 18px;
  font-size: 0.8rem;
  color: rgba(248, 250, 252, 0.72);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-table-wizard__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px 18px;
}

.lt-table-wizard__loading,
.lt-table-wizard__empty-msg {
  text-align: center;
  color: rgba(248, 250, 252, 0.55);
  padding: 24px;
}

.lt-table-wizard__tables {
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  align-content: start;
}

.lt-table-wizard__tables > .lt-coach-table {
  padding: 5px 7px;
  min-height: 0;
  height: auto;
}

.lt-table-wizard__tables > .lt-coach-table--multi {
  height: auto;
  min-height: 0;
  padding: 6px 8px;
  overflow: visible;
}

.lt-table-wizard__card {
  margin: 0;
}

.lt-table-wizard__unassigned {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 16%, transparent);
  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 35%, transparent);
}

.lt-table-wizard__unassigned h3 {
  margin: 0 0 8px;
  font-size: 0.88rem;
  color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 40%, #fde68a);
}

.lt-table-wizard__unassigned ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.lt-table-wizard__unassigned li {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 0.82rem;
  color: rgba(248, 250, 252, 0.85);
}

.lt-table-wizard__footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 18px 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.55);
}

.lt-table-wizard__nav-btn {
  padding: 10px 18px;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 45%, transparent);
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 16%, transparent);
  font-weight: 600;
  cursor: pointer;
  color: #f8fafc;
}

.lt-table-wizard__nav-btn--primary {
  background: linear-gradient(
    135deg,
    var(--lt-brand, #0877bc) 0%,
    color-mix(in srgb, var(--lt-brand, #0877bc) 78%, #000) 100%
  );
  border-color: var(--lt-brand, #0877bc);
  color: #fff;
}

@media (max-width: 640px) {
  .lt-table-wizard__backdrop {
    padding: 0;
    align-items: stretch;
  }

  .lt-table-wizard {
    max-height: 100vh;
    border-radius: 0;
  }

  .lt-table-wizard__toolbar {
    flex-direction: column;
  }

  .lt-table-wizard__tool-group {
    width: 100%;
  }
}

@media (orientation: landscape) {
  .lt-table-wizard__backdrop {
    padding: 6px;
    padding-bottom: var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));
    align-items: stretch;
  }

  .lt-table-wizard {
    width: min(960px, 100%);
    max-height: calc(
      100dvh - var(--lt-coach-bar-reserve, 68px) - 12px - env(safe-area-inset-top)
    );
    height: calc(
      100dvh - var(--lt-coach-bar-reserve, 68px) - 12px - env(safe-area-inset-top)
    );
  }

  .lt-table-wizard__header {
    padding: 8px 12px 6px;
  }

  .lt-table-wizard__header h2 {
    font-size: 1rem;
  }

  .lt-table-wizard__toolbar {
    padding: 6px 12px;
    gap: 6px;
  }

  .lt-table-wizard__tool-group {
    padding: 4px 8px;
  }

  .lt-table-wizard__body {
    padding: 8px 12px;
  }

  .lt-table-wizard__tables {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 5px;
  }

  .lt-table-wizard__tables > .lt-coach-table {
    padding: 5px 7px;
  }

  .lt-table-wizard__footer {
    padding: 6px 12px 8px;
  }
}

@media (orientation: landscape) and (min-width: 900px) {
  .lt-table-wizard__tables {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

@media (orientation: landscape) and (max-height: 520px) {
  .lt-table-wizard__tables {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 4px;
  }

  .lt-table-wizard__toolbar {
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  .lt-table-wizard__tool-group {
    flex: 0 0 auto;
  }
}


/* Light mode — shared wizard / live-training dialogs */
.light-mode .lt-table-wizard {
  background: linear-gradient(
    165deg,
    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 10%, #f8fafc) 0%,
    #ffffff 52%,
    #f1f5f9 100%
  );
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-table-wizard__header h2 {
  color: #0f172a;
}

.light-mode .lt-table-wizard__subtitle {
  color: #475569;
}

.light-mode .lt-table-wizard__close {
  background: rgba(15, 23, 42, 0.05);
  border-color: rgba(15, 23, 42, 0.12);
  color: #0f172a;
}

.light-mode .lt-table-wizard__banner {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-table-wizard__backdrop {
  background: rgba(15, 23, 42, 0.45);
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingTableSetupWizard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,qFAAqF;AACvF;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B;;;;;GAKC;EACD,+EAA+E;EAC/E,mBAAmB;EACnB;;6CAE2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0EAA0E;AAC5E;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,2EAA2E;EAC3E,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,kDAAkD;EAClD,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0EAA0E;AAC5E;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd;;;;kBAIgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qFAAqF;EACrF,mFAAmF;AACrF;;AAEA;EACE,8EAA8E;EAC9E,mFAAmF;AACrF;;AAEA;EACE,2EAA2E;EAC3E,yEAAyE;AAC3E;;AAEA;EACE,2EAA2E;EAC3E,yEAAyE;EACzE,mFAAmF;AACrF;;AAEA;EACE,sCAAsC;EACtC,yEAAyE;EACzE,mFAAmF;AACrF;;AAEA;EACE,sCAAsC;EACtC;;;;GAIC;EACD,WAAW;AACb;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2EAA2E;EAC3E,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;EACT,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,+EAA+E;EAC/E,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mFAAmF;AACrF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,2EAA2E;EAC3E,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,mFAAmF;EACnF,gGAAgG;EAChG,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,yEAAyE;EACzE,gEAAgE;EAChE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,kDAAkD;AACpD;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mFAAmF;EACnF,yFAAyF;AAC3F;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kDAAkD;EAClD,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yFAAyF;EACzF,mFAAmF;EACnF,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;;;;GAIC;EACD,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;IACZ,qFAAqF;IACrF,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB;;KAEC;IACD;;KAEC;EACH;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4DAA4D;IAC5D,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,4DAA4D;IAC5D,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;;;AAGA,uDAAuD;AACvD;EACE;;;;;GAKC;EACD,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kEAAkE;EAClE,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".lt-table-wizard__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  background: rgba(15, 23, 42, 0.72);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 12px;\n  padding-bottom: var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));\n}\n\n.lt-table-wizard {\n  width: min(920px, 100%);\n  max-height: min(92vh, 900px);\n  background: linear-gradient(\n    165deg,\n    #0f172a 0%,\n    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 18%, #1e293b) 45%,\n    #0f172a 100%\n  );\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);\n  border-radius: 16px;\n  box-shadow:\n    0 24px 48px rgba(0, 0, 0, 0.45),\n    0 0 0 1px rgba(255, 255, 255, 0.04) inset;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  color: #f8fafc;\n}\n\n.lt-table-wizard__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px 18px 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-table-wizard__header h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #f8fafc;\n}\n\n.lt-table-wizard__subtitle {\n  margin: 4px 0 0;\n  font-size: 0.8rem;\n  color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, #f8fafc);\n}\n\n.lt-table-wizard__close {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #f8fafc;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.lt-table-wizard__close:hover {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.16);\n}\n\n.lt-table-wizard__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 12px 18px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.55);\n}\n\n.lt-table-wizard__tool-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.lt-table-wizard__tool-label {\n  width: 100%;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 70%, #f8fafc);\n}\n\n.lt-table-wizard__tool-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 8px 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.06);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  color: #f8fafc;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    box-shadow 0.15s,\n    transform 0.1s;\n}\n\n.lt-table-wizard__tool-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.lt-table-wizard__tool-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.lt-table-wizard__tool-btn--secondary {\n  border-color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, transparent);\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 18%, transparent);\n}\n\n.lt-table-wizard__tool-btn--secondary:hover:not(:disabled) {\n  border-color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 75%, #fff);\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 28%, transparent);\n}\n\n.lt-table-wizard__tool-btn--rotate {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, transparent);\n}\n\n.lt-table-wizard__tool-btn--rotate:hover:not(:disabled) {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 65%, transparent);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);\n}\n\n.lt-table-wizard__tool-btn--active {\n  border-color: var(--lt-brand, #0877bc);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);\n}\n\n.lt-table-wizard__tool-btn--apply {\n  border-color: var(--lt-brand, #0877bc);\n  background: linear-gradient(\n    135deg,\n    var(--lt-brand, #0877bc) 0%,\n    color-mix(in srgb, var(--lt-brand, #0877bc) 78%, #000) 100%\n  );\n  color: #fff;\n}\n\n.lt-table-wizard__tool-btn--apply:hover:not(:disabled) {\n  box-shadow: 0 8px 20px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);\n}\n\n.lt-table-wizard__voice {\n  flex: 1 1 220px;\n  min-width: min(100%, 240px);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lt-table-wizard__tool-group--voice {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, transparent);\n}\n\n.lt-table-wizard__voice-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.lt-table-wizard__voice-hint {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: rgba(248, 250, 252, 0.78);\n}\n\n.lt-table-wizard__voice-box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);\n  background: rgba(15, 23, 42, 0.92);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);\n}\n\n.lt-table-wizard__voice-box-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.88);\n}\n\n.lt-table-wizard__voice-dismiss {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: rgba(248, 250, 252, 0.7);\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.lt-table-wizard__voice-dismiss:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\n.lt-table-wizard__voice-input {\n  width: 100%;\n  resize: vertical;\n  min-height: 52px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(2, 6, 23, 0.55);\n  color: #f8fafc;\n  font: inherit;\n  font-size: 0.86rem;\n  line-height: 1.4;\n}\n\n.lt-table-wizard__voice-input:focus {\n  outline: none;\n  border-color: var(--lt-brand, #0877bc);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);\n}\n\n.lt-table-wizard__voice-actions {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.lt-table-wizard__banner--voice {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, transparent);\n}\n\n.lt-table-wizard__swap-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 18px;\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 22%, transparent);\n  border-bottom: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 35%, transparent);\n  font-size: 0.82rem;\n  color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 35%, #fde68a);\n}\n\n.lt-table-wizard__banner {\n  margin: 0;\n  padding: 8px 18px;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);\n  color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #86efac);\n  font-size: 0.82rem;\n}\n\n.lt-table-wizard__banner--error {\n  background: rgba(239, 68, 68, 0.15);\n  color: #fecaca;\n}\n\n.lt-table-wizard__banner--warn {\n  background: rgba(251, 191, 36, 0.14);\n  color: #fde68a;\n}\n\n.lt-table-wizard__kot-hint {\n  margin: 0;\n  padding: 8px 18px;\n  font-size: 0.8rem;\n  color: rgba(248, 250, 252, 0.72);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-table-wizard__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 18px;\n}\n\n.lt-table-wizard__loading,\n.lt-table-wizard__empty-msg {\n  text-align: center;\n  color: rgba(248, 250, 252, 0.55);\n  padding: 24px;\n}\n\n.lt-table-wizard__tables {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 6px;\n  align-content: start;\n}\n\n.lt-table-wizard__tables > .lt-coach-table {\n  padding: 5px 7px;\n  min-height: 0;\n  height: auto;\n}\n\n.lt-table-wizard__tables > .lt-coach-table--multi {\n  height: auto;\n  min-height: 0;\n  padding: 6px 8px;\n  overflow: visible;\n}\n\n.lt-table-wizard__card {\n  margin: 0;\n}\n\n.lt-table-wizard__unassigned {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 16%, transparent);\n  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 35%, transparent);\n}\n\n.lt-table-wizard__unassigned h3 {\n  margin: 0 0 8px;\n  font-size: 0.88rem;\n  color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 40%, #fde68a);\n}\n\n.lt-table-wizard__unassigned ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.lt-table-wizard__unassigned li {\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 0.82rem;\n  color: rgba(248, 250, 252, 0.85);\n}\n\n.lt-table-wizard__footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px 18px 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.55);\n}\n\n.lt-table-wizard__nav-btn {\n  padding: 10px 18px;\n  border-radius: 10px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 45%, transparent);\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 16%, transparent);\n  font-weight: 600;\n  cursor: pointer;\n  color: #f8fafc;\n}\n\n.lt-table-wizard__nav-btn--primary {\n  background: linear-gradient(\n    135deg,\n    var(--lt-brand, #0877bc) 0%,\n    color-mix(in srgb, var(--lt-brand, #0877bc) 78%, #000) 100%\n  );\n  border-color: var(--lt-brand, #0877bc);\n  color: #fff;\n}\n\n@media (max-width: 640px) {\n  .lt-table-wizard__backdrop {\n    padding: 0;\n    align-items: stretch;\n  }\n\n  .lt-table-wizard {\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .lt-table-wizard__toolbar {\n    flex-direction: column;\n  }\n\n  .lt-table-wizard__tool-group {\n    width: 100%;\n  }\n}\n\n@media (orientation: landscape) {\n  .lt-table-wizard__backdrop {\n    padding: 6px;\n    padding-bottom: var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));\n    align-items: stretch;\n  }\n\n  .lt-table-wizard {\n    width: min(960px, 100%);\n    max-height: calc(\n      100dvh - var(--lt-coach-bar-reserve, 68px) - 12px - env(safe-area-inset-top)\n    );\n    height: calc(\n      100dvh - var(--lt-coach-bar-reserve, 68px) - 12px - env(safe-area-inset-top)\n    );\n  }\n\n  .lt-table-wizard__header {\n    padding: 8px 12px 6px;\n  }\n\n  .lt-table-wizard__header h2 {\n    font-size: 1rem;\n  }\n\n  .lt-table-wizard__toolbar {\n    padding: 6px 12px;\n    gap: 6px;\n  }\n\n  .lt-table-wizard__tool-group {\n    padding: 4px 8px;\n  }\n\n  .lt-table-wizard__body {\n    padding: 8px 12px;\n  }\n\n  .lt-table-wizard__tables {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 5px;\n  }\n\n  .lt-table-wizard__tables > .lt-coach-table {\n    padding: 5px 7px;\n  }\n\n  .lt-table-wizard__footer {\n    padding: 6px 12px 8px;\n  }\n}\n\n@media (orientation: landscape) and (min-width: 900px) {\n  .lt-table-wizard__tables {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n}\n\n@media (orientation: landscape) and (max-height: 520px) {\n  .lt-table-wizard__tables {\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 4px;\n  }\n\n  .lt-table-wizard__toolbar {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n  }\n\n  .lt-table-wizard__tool-group {\n    flex: 0 0 auto;\n  }\n}\n\n\n/* Light mode — shared wizard / live-training dialogs */\n.light-mode .lt-table-wizard {\n  background: linear-gradient(\n    165deg,\n    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 10%, #f8fafc) 0%,\n    #ffffff 52%,\n    #f1f5f9 100%\n  );\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-table-wizard__header h2 {\n  color: #0f172a;\n}\n\n.light-mode .lt-table-wizard__subtitle {\n  color: #475569;\n}\n\n.light-mode .lt-table-wizard__close {\n  background: rgba(15, 23, 42, 0.05);\n  border-color: rgba(15, 23, 42, 0.12);\n  color: #0f172a;\n}\n\n.light-mode .lt-table-wizard__banner {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-table-wizard__backdrop {\n  background: rgba(15, 23, 42, 0.45);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
